import BottomFooter from "./bottom-footer";

export default BottomFooter;